module.exports = __webpack_public_path__ + "img/4.44e4e536.jpg";